import moment from 'moment'

// The recent filter is relative, even when its old concrete dates were persisted in localStorage.
// Called only by the useDocuAi Documents request path; never mutates saved or shared filter objects.
export const refreshDocumentRecentFilter = ({ filter, quickFilter, filterItems = [] }, now = moment()) => {
  const recent = {
    updatedAt: {
      dateFrom: now.clone().subtract(24, 'hours').toDate(),
      dateTo: now.clone().endOf('day').toDate(),
      filterType: 'datetime',
      type: 'inRange',
    },
  }

  return {
    quickFilter: filter === 'lastUpdated' ? recent : quickFilter,
    filterItems: filterItems.map(item => item.name === 'lastUpdated' ? { ...item, quickFilter: recent } : item),
  }
}
